module.exports = __webpack_public_path__ + "static/assets/bb59f04e7f0aabe8e142ac1607a03dd6.otf";